import type { MouseEvent } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages";
import { useSiteSelectorContext } from "@/components/site-selector-modal";
import { useGupsStatus } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks";

const templateButtonActionLinkStyles = css({
    "alignItems": "center",
    "justifyContent": "center",
    "background": "#0052cc",
    "borderRadius": "0.25rem",
    "boxSizing": "border-box",
    "display": "inline-flex",
    "minWidth": 128,
    "margin": 0,
    "height": 32,
    "border": "none",
    "lineHeight": "1.875rem",
    "textAlign": "center",
    "cursor": "pointer",
    "padding": "0 16px",
    "fontSize": ".875rem",
    "fontWeight": 500,
    "fontFamily": "var(--font-family-charlie-text)",
    "color": "#ffffff",
    "textDecoration": "none",
    "zIndex": 1,
    ":hover, :focus": {
        background: "#0047B3"
    },
    ":active": {
        background: "#004099"
    }
});

interface TemplateCardProps {
    blueprintModuleKey?: string | null;
    templateName: string;
}

export const UseTemplateButton = ({
    blueprintModuleKey,
    templateName
}: TemplateCardProps) => {
    const { openModalForTemplate } = useSiteSelectorContext();
    const { addTemplateCardCallback } = useGupsStatus();

    const navigateToUseTemplate = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();

        const templateId = blueprintModuleKey ?? "";
        openModalForTemplate({
            templateId,
            templateName,
            productKey: ProductKeys.CONFLUENCE
        });
        addTemplateCardCallback(templateId);
    };

    return (
        <button
            css={templateButtonActionLinkStyles}
            onClick={navigateToUseTemplate}
            className="doNotAutoTrack"
        >
            <FormattedMessage {...ConfluenceTemplateMessages.useTemplate} />
        </button>
    );
};
